var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "color-preview",
    class: {
      'color-preview--colorful': _vm.colorful
    },
    style: (_vm.containerStyle)
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f163ca40","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ColorPreview.vue
// module id = 2142
// module chunks = 0